import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import axios from "axios";
import { AppProvider } from "@/context/AppContext";
import PublicSite from "@/PublicSite";
import HQRoot from "@/hq/HQRoot";
import OptimisePage from "@/OptimisePage";
import OptimiseReport from "@/OptimiseReport";
import OptimiseContinue from "@/optimise/OptimiseContinue";
import Unsubscribe from "@/Unsubscribe";
import PayPage from "@/PayPage";
import CustomerFixStatus from "@/CustomerFixStatus";
import AgreementReviewPage from "@/pages/AgreementReviewPage";
import InterestConfirmPage from "@/pages/InterestConfirmPage";

// Phase 3I.4R — Privacy-conscious first-party page view tracker.
// Fires POST /api/track/pageview on every route change EXCEPT authenticated
// HQ paths (Command Centre analytics should never count operator's own
// navigation as public web traffic). Phase 3I.4U extends the skip list
// to secure token pages + preview/test routes so Digital Footfall
// answers "genuine public visitors" only.
const NON_PUBLIC_PATH_RE = /^\/(hq|interest|api|admin|pay|fix|agreement|unsubscribe)(\/|$)|^\/(priv-test-|test-throttle-|test-)|^\/public-test$/;
function PageViewTracker() {
  const loc = useLocation();
  useEffect(() => {
    const path = loc.pathname || "/";
    if (NON_PUBLIC_PATH_RE.test(path)) return;
    const base = process.env.REACT_APP_BACKEND_URL;
    if (!base) return;
    axios.post(`${base}/api/track/pageview`,
               { path, referrer: document.referrer || null },
               { withCredentials: true })
         .catch(() => { /* fail-soft, never disrupt UX */ });
  }, [loc.pathname]);
  return null;
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <PageViewTracker/>
        <Routes>
          <Route path="/hq/*" element={<HQRoot />} />
          <Route path="/optimise/report/:token" element={<OptimiseReport />} />
          <Route path="/optimise/continue/:token" element={<OptimiseContinue />} />
          <Route path="/optimise" element={<OptimisePage />} />
          <Route path="/unsubscribe/:token" element={<Unsubscribe />} />
          <Route path="/pay/:token" element={<PayPage />} />
          <Route path="/fix/:token" element={<CustomerFixStatus />} />
          <Route path="/agreement/:token" element={<AgreementReviewPage />} />
          <Route path="/interest/:token" element={<InterestConfirmPage />} />
          <Route path="/*" element={<PublicSite />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
